import React from 'react';
import { Button, Box, Flex, Text } from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';

interface BackButtonProps {
  to: string;
  label?: string;
}

/**
 * Reusable back button component with enhanced Chakra UI styling
 * Positioned at the top of the page for consistent navigation
 * Adjusted for mobile to avoid overlapping with hamburger menu
 */
const BackButton: React.FC<BackButtonProps> = ({ to, label = 'Back' }) => {
  return (
    <Box 
      mb={6}
      bg="white"
      borderRadius="full"
      py={2}
      px={4}
      boxShadow="sm"
      border="1px solid"
      borderColor="gray.200"
      maxWidth="fit-content"
      transition="all 0.2s"
      _hover={{
        boxShadow: "md",
        borderColor: "blue.300"
      }}
    >
      <RouterLink to={to}>
        <Flex align="center">
          <ChevronLeftIcon w={6} h={6} color="blue.500" mr={1} />
          <Text color="blackAlpha.800" fontWeight="medium">
            {label}
          </Text>
        </Flex>
      </RouterLink>
    </Box>
  );
};

export default BackButton; 